import { useState } from "react";
import { BookOpen } from "lucide-react";
import { api } from "../../lib/api";
import { money, uid } from "../../lib/format";
import { Button } from "../ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../ui/command";

const UNIT = { each: "ea", length: "/m", area: "/m²" };

export const PriceListPicker = ({ onPick }) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const onOpenChange = (o) => {
    setOpen(o);
    if (o) api.get("/price-items").then((r) => setItems(r.data));
  };
  const groups = items.reduce((g, i) => ({ ...g, [i.category || "Uncategorised"]: [...(g[i.category || "Uncategorised"] || []), i] }), {});
  const pick = (p) => { setOpen(false); onPick({ id: uid(), description: p.name, pricing_type: p.pricing_type, quantity: 1, length: p.pricing_type === "each" ? 0 : 1, width: p.pricing_type === "area" ? 1 : 0, unit_price: p.unit_price }); };

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <Button data-testid="add-from-price-list-button" variant="outline" size="sm"><BookOpen className="mr-1 h-4 w-4" />Add from price list</Button>
      </PopoverTrigger>
      <PopoverContent className="w-[420px] p-0" align="start">
        <Command>
          <CommandInput data-testid="price-list-search" placeholder="Search pipes, fittings, labour…" />
          <CommandList className="max-h-80">
            <CommandEmpty>No saved items. Add some on the Price List page.</CommandEmpty>
            {Object.entries(groups).map(([cat, list]) => (
              <CommandGroup key={cat} heading={cat}>
                {list.map((p) => (
                  <CommandItem key={p.id} value={`${p.name} ${cat}`} data-testid={`price-list-option-${p.id}`} onSelect={() => pick(p)} className="flex justify-between">
                    <span>{p.name}</span>
                    <span className="font-mono text-xs text-zinc-500">{money(p.unit_price)} {UNIT[p.pricing_type]}</span>
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
